import { getResourceFromCms } from '@namespace/helpers';

export const getBonusTmplCms = (contentTemplateId) => {
  return getResourceFromCms(`/bonus?bonusTemplateIds[]=${contentTemplateId}`);
};
